/**
 * element-ui组件主题
 *
 * tips:
 *  1. 此处只包含element-ui组件主题
 *  2. 要达到整站主题修改效果, 请确保[import './element-[#409EFF]/index.css']当前主题色与[/src/assets/scss/_variables.scss]文件中[$--color-primary]属性值一致
 */
import "./element-#409EFF/index.css"; // 当前主题色
export default {
  list: [
    "#409EFF", // 官网默认
  ],
};
